import { Action } from "redux";

export type PartiallyBuiltElementsHiddenEvent = Action<typeof PARTIALLY_BUILT_ELEMENTS_HIDDEN>

export const PARTIALLY_BUILT_ELEMENTS_HIDDEN = "partially_built_elements_hidden";

export const partiallyBuiltElementsHidden = (): PartiallyBuiltElementsHiddenEvent => ({
  type: PARTIALLY_BUILT_ELEMENTS_HIDDEN,
});
